<template>
  <button
    class="cursor-pointer rounded shadow font-sans w-full hover:opacity-75 transition-opacity ease-in-out duration-200 border-highlight text-white bg-transparent border border-solid flex items-center justify-center"
    @click="$emit('click', $event)"
  >
    <img src="./assets/logo.png" width="21" height="21" alt="" />
    <span class="ml-2">
      Sign in with Microsoft
    </span>
  </button>
</template>

<script>
export default { name: "microsoft-logo" };
</script>

<style scoped>
button {
  padding: 0.4rem 1.5rem;
}
</style>
